var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8281 10.1235C49.8097 9.18673 48.4612 8.69222 47.0786 8.74846C45.696 8.8047 44.3921 9.4071 43.4531 10.4235L26.2531 27.6235L23.3281 37.6235L33.3281 34.6985L50.5281 17.6235C51.0501 17.1568 51.473 16.59 51.7716 15.9568C52.0702 15.3235 52.2385 14.6366 52.2665 13.937C52.2945 13.2374 52.1816 12.5393 51.9345 11.8842C51.6874 11.2291 51.3112 10.6303 50.8281 10.1235Z",
    stroke: "#00C853",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8281 7.62305H10.8281C10.1651 7.62305 9.5292 7.88644 9.06036 8.35528C8.59152 8.82412 8.32813 9.46001 8.32812 10.123V50.123C8.32813 50.7861 8.59152 51.422 9.06036 51.8908C9.5292 52.3597 10.1651 52.623 10.8281 52.623H50.8281C51.4912 52.623 52.1271 52.3597 52.5959 51.8908C53.0647 51.422 53.3281 50.7861 53.3281 50.123V30.123",
    stroke: "#00C853",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCsv);
export default __webpack_public_path__ + "static/media/CreateCSV.8175bed7ed3c41c7f7bedb56cb035a7b.svg";
export { ForwardRef as ReactComponent };